import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/PeticionVenta/peticionventa';
import PVpreview from './PVpreview';

const mstp = state => {
    return {...state.peticionV}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(PVpreview)
